export default "__VITE_ASSET__c3f0f95b__"